// The search page's address holds the words: /search/<words>. A link encodes them once (a space, a slash, a "?" or
// a "#" would otherwise break the address or be lost), and the page decodes the route's segment once: Next.js hands
// it over still percent-encoded, so "big tits" was searched as "big%20tits" and アニメ as "%E3%82%A2…", which found
// nothing (ai_app_backend #1556).

/** The search page's address for these words, each character encoded once. */
export function searchPath(words) {
  return `/search/${encodeURIComponent(words)}`
}

/**
 * The words in the route's segment, decoded once. A segment that isn't valid percent-encoding (a stray "%") is kept
 * as it came, never an error on the page.
 */
export function searchWordsFromPath(segment) {
  if (typeof segment !== 'string') return segment ?? null
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}
